import React from 'react'
import {getColor} from 'components/utils'
import { TransProps } from '@lingui/react'
import {
    SearchIcon,
    XIcon,
} from '@heroicons/react/outline'


// Type
export type typeInputSearch = {
    variant?: string
    id: string
    name?: string
    label?: React.ReactElement<TransProps>
    placeholder?: string
    value?: string
    required?: boolean
    labelClassName?: string,
    inputClassName?: string,
    inputWrapClassName?: string,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onClear?: () => void
    onKeyEnterDown?: (e:React.KeyboardEvent<HTMLInputElement>) => void
    onFocus?: React.FocusEventHandler<HTMLInputElement>
    autoComplete?: string | undefined;
}


// Component
export const InputSearch:React.FC<typeInputSearch> = ({
    variant,
    id,
    name,
    label,
    placeholder,
    value,
    required=false,
    labelClassName,
    inputClassName,
    inputWrapClassName,
    onChange,
    onKeyEnterDown,
    onClear,
    onFocus,
    autoComplete
}) => {

    const color = getColor(variant)

    const labelStyles = ['block mb-1 text-sm font-medium text-gray-700', labelClassName].join(' ')
    const inputStyles = [`pl-11 pr-11 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-${color}-500 focus:border-${color}-500 sm:text-sm`, inputClassName].join(' ')

    const onClearHandler = () => {
        if (onClear) onClear()
    }

    const onKeyEnterDownHandler = (e:React.KeyboardEvent<HTMLInputElement>) => {
        if(e.key === 'Enter') {
            if (onKeyEnterDown) onKeyEnterDown(e)
        }
    }

    return(
        <>
            {label
                ? <label
                    htmlFor={id}
                    className={labelStyles}
                >
                    {label}
                </label>
                : null
            }

            <div className={ `relative rounded-md ${ inputWrapClassName || '' }` }>
                <div className="absolute inset-y-0 left-0 pl-3 pr-3 flex items-center pointer-events-none">
                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
                {onClear && value
                    ? <div className="absolute inset-y-0 right-0 pl-3 pr-3 flex items-center pointer-events-auto cursor-pointer" onClick={() => onClearHandler()}>
                        <XIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    : null
                }

                <input
                    id={id}
                    name={name}
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    required={required}
                    onChange={onChange}
                    onKeyDown={(e) => onKeyEnterDownHandler(e)}
                    className={inputStyles}
                    maxLength={150}
                    onFocus={onFocus}
                    autoComplete={autoComplete}
                />
            </div>
        </>
    )
}
